<div class="grid">
    <div class="
    col-12
    sm:col-12
    md:col-3
    lg:col-3
    xl:col-3
    text-center
    ">
      <app-custom-item-card-image-wish-list [product]="product" />
    </div>
    <div class="
            col-12
            sm:col-12
            md:col-8
            lg:col-8
            xl:col-8
            ">
            <div class="grid">
                <div class="
                col-12
                sm:col-12
                md:col-5
                lg:col-5
                xl:col-5
                flex
                justify-content-center
                align-items-center
                ">
                <app-custom-item-card-body-wish-list [product]="product"/>
              </div>

                <div class="
                    col-12
                    sm:col-12
                    md:col-4
                    lg:col-4
                    xl:col-4
                    flex
                    justify-content-center
                    align-items-center
                    ">
                    <div class="p-fluid">
                        <div class="p-field">
                            <custom-input-number-control
                            [(ngValue)]="product.cant"
                            (ngValueChange)="changeCant($event)"
                            [stock]="stock"
                            [mediumSizeFlexColumButton]="true"
                            ></custom-input-number-control >
                        </div>
                    </div>
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-3
                    lg:col-3
                    xl:col-3
                    text-right
                    ">
                    <p class="font-bold md:font-semibold text-center">{{ showTotalPrice() | currency }}</p>
                </div>
            </div>

    </div>
    <div class="
            col-12
            sm:col-12
            md:col-1
            lg:col-1
            xl:col-1
            flex
            justify-content-center
            align-items-center
            ">
            <custom-button
                    [icon]="'pi pi-trash'"
                    (click)="delete()"
                    ></custom-button>
    </div>
</div>
<hr style="margin-bottom: 15px;">

<app-delete-item-wish-list-modal
[visible]="deleteProductCar"
[product]="product.product"
(noVisible)="closeModal($event)"
(deleted)="closeModalAndDelete($event)"
></app-delete-item-wish-list-modal>
